/* eslint-disable max-lines -- one import list plus one name-to-icon map; splitting would only scatter the registry */
import {
  Activity,
  Archive,
  ArrowDown,
  ArrowLeft,
  ArrowLeftRight,
  ArrowRight,
  ArrowUp,
  ArrowUpDown,
  Atom,
  Baby,
  BadgePercent,
  Ban,
  Bell,
  Bike,
  BriefcaseBusiness,
  Building2,
  Bus,
  Calendar,
  CalendarClock,
  CalendarDays,
  CalendarOff,
  CalendarPlus,
  CalendarX,
  Camera,
  CameraOff,
  Car,
  ChartBar,
  ChartColumnBig,
  ChartPie,
  Check,
  CheckCircle,
  ChevronDown,
  ChevronLeft,
  ChevronRight,
  ChevronsLeft,
  ChevronsRight,
  ChevronsUpDown,
  ChevronUp,
  Circle,
  CircleAlert,
  CircleCheck,
  CircleDollarSign,
  CircleHelp,
  CircleQuestionMark,
  CircleUserRound,
  CircleX,
  ClipboardCheck,
  ClipboardList,
  Clock,
  CloudRain,
  Coffee,
  Combine,
  Contact,
  Copy,
  CreditCard,
  Cylinder,
  Database,
  DollarSign,
  DoorOpen,
  Download,
  Droplet,
  Edit,
  EllipsisVertical,
  Eye,
  EyeOff,
  FileSpreadsheet,
  FileText,
  Filter,
  Flag,
  Flame,
  FlaskConical,
  FolderKanban,
  Frown,
  Fuel,
  GalleryVerticalEnd,
  Gauge,
  Gift,
  GitFork,
  Globe,
  Grid2X2,
  Grip,
  GripVertical,
  HandCoins,
  Handshake,
  Hash,
  Heart,
  Home,
  Hotel,
  HousePlus,
  ImageOff,
  Images,
  Info,
  Key,
  Languages,
  Layers,
  LayoutDashboard,
  Lightbulb,
  Link,
  List,
  ListCheck,
  ListTodo,
  Loader2,
  LocateFixed,
  LocationEdit,
  Lock,
  LockOpen,
  LogOut,
  Luggage,
  Mail,
  Map,
  MapPin,
  Maximize2,
  Menu,
  Merge,
  MessageSquare,
  Minimize2,
  Minus,
  Monitor,
  Moon,
  MoreHorizontal,
  MountainSnow,
  Navigation,
  Package,
  PackageCheck,
  PackageMinus,
  PackagePlus,
  PackageSearch,
  Palette,
  PanelLeft,
  Pause,
  Phone,
  PiggyBank,
  Pin,
  Pipette,
  Play,
  PlugZap,
  Plus,
  Power,
  Printer,
  QrCode,
  Receipt,
  ReceiptText,
  RefreshCcw,
  RefreshCw,
  Repeat,
  Repeat2,
  RotateCcw,
  Route,
  Ruler,
  Save,
  ScanLine,
  Search,
  Send,
  Settings,
  Settings2,
  Share,
  Shield,
  ShieldCheck,
  ShoppingCart,
  Shuffle,
  SlidersHorizontal,
  Smile,
  Snowflake,
  Sparkles,
  Sprout,
  Square,
  SquareArrowOutUpRight,
  SquareCheck,
  Star,
  Stethoscope,
  StickyNote,
  Store,
  Sun,
  SunSnow,
  SwitchCamera,
  Table,
  Tag,
  Target,
  TestTubes,
  Thermometer,
  ThumbsDown,
  ThumbsUp,
  Ticket,
  Trash2,
  TreePalm,
  TrendingDown,
  TrendingUp,
  TriangleAlert,
  Truck,
  Undo2,
  Upload,
  User,
  UserCheck,
  UserMinus,
  UserPlus,
  Users,
  UserX,
  Volume2,
  VolumeX,
  WandSparkles,
  Warehouse,
  Webhook,
  Wrench,
  X,
  XCircle,
  Zap
} from 'lucide-react-native';

export const lucideIconsMap = {
  Activity,
  Archive,
  ArrowDown,
  ArrowLeft,
  ArrowLeftRight,
  ArrowRight,
  ArrowUp,
  ArrowUpDown,
  Atom,
  Baby,
  BadgePercent,
  Ban,
  BarChart3: ChartBar, // Map BarChart3 to ChartBar which is available in lucide-react-native,
  Bell,
  Bike,
  BriefcaseBusiness,
  Building2,
  Bus,
  Calendar,
  CalendarClock,
  CalendarDays,
  CalendarOff,
  CalendarPlus,
  CalendarX,
  Camera,
  CameraOff,
  Car,
  ChartBar,
  ChartColumnBig,
  ChartPie,
  Check,
  CheckCircle,
  ChevronDown,
  ChevronLeft,
  ChevronRight,
  ChevronsLeft,
  ChevronsRight,
  ChevronsUpDown,
  ChevronUp,
  Circle,
  CircleAlert,
  CircleCheck,
  CircleDollarSign,
  CircleHelp,
  CircleQuestionMark,
  CircleUserRound,
  CircleX,
  ClipboardCheck,
  ClipboardList,
  Clock,
  CloudRain,
  Coffee,
  Combine,
  Contact,
  Copy,
  CreditCard,
  Cylinder,
  Database,
  DollarSign,
  DoorOpen,
  Download,
  Droplet,
  Edit,
  Eye,
  EyeOff,
  EllipsisVertical,
  FileSpreadsheet,
  FileText,
  Filter,
  Flame,
  FlaskConical,
  Flag,
  FolderKanban,
  Frown,
  Fuel,
  GalleryVerticalEnd,
  Gauge,
  Gift,
  GitFork,
  Globe,
  Grid2X2,
  Grip,
  GripVertical,
  HandCoins,
  Handshake,
  Hash,
  Heart,
  Home,
  Hotel,
  HousePlus,
  ImageOff,
  Images,
  Info,
  Key,
  Languages,
  Layers,
  LayoutDashboard,
  Lightbulb,
  Link,
  List,
  ListCheck,
  ListTodo,
  Loader2,
  LocateFixed,
  LocationEdit,
  Lock,
  LockOpen,
  LogOut,
  Luggage,
  Mail,
  Map,
  MapPin,
  Maximize2,
  MountainSnow,
  Menu,
  Merge,
  MessageSquare,
  Minimize2,
  Minus,
  Monitor,
  Moon,
  MoreHorizontal,
  Navigation,
  Package,
  PackageCheck,
  PackageMinus,
  PackagePlus,
  PackageSearch,
  Palette,
  PanelLeft,
  Pause,
  Phone,
  PiggyBank,
  Pin,
  Pipette,
  Play,
  PlugZap,
  Plus,
  Power,
  Printer,
  QrCode,
  Receipt,
  ReceiptText,
  RefreshCcw,
  RefreshCw,
  Repeat,
  Repeat2,
  RotateCcw,
  Route,
  Ruler,
  Save,
  ScanLine,
  Search,
  Send,
  Settings,
  Settings2,
  Share,
  Shield,
  ShieldCheck,
  ShoppingCart,
  Shuffle,
  SlidersHorizontal,
  Smile,
  Snowflake,
  Sparkles,
  Sprout,
  Square,
  SquareArrowOutUpRight,
  SquareCheck,
  Star,
  Stethoscope,
  StickyNote,
  Store,
  Sun,
  SunSnow,
  SwitchCamera,
  Table,
  Tag,
  Target,
  TestTubes,
  Thermometer,
  ThumbsDown,
  ThumbsUp,
  Ticket,
  Trash2,
  TreePalm,
  TrendingDown,
  TrendingUp,
  TriangleAlert,
  Truck,
  Undo2,
  Upload,
  User,
  UserCheck,
  UserMinus,
  UserPlus,
  UserX,
  Users,
  Volume2,
  VolumeX,
  WandSparkles,
  Warehouse,
  Webhook,
  Wrench,
  X,
  XCircle,
  Zap
};
